import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

type CaptchaProps = {
  onChange: (token: string | null) => void;
};

const Captcha = ({ onChange }: CaptchaProps): JSX.Element => {
  return (
    <ReCAPTCHA
      sitekey={process.env.GOOGLE_RECAPTCHA_SITE_KEY}
      onChange={onChange}
    />
  );
};

export default Captcha;
